/** Pure action gates for Follow Up Now. The browser must use backend-resolved
 * canonical facts; display fallbacks are never recipient authorization. */
export function canonicalEmailGate(facts) {
  if (facts?.email_allowed === true) return { allowed: true, reason: "" };
  return {
    allowed: false,
    reason: facts?.email_reason
      || "Email is unavailable until an explicit linked contact with an allowed email address is resolved.",
  };
}

export function canonicalCallGate(facts, role) {
  const roleAllowed = ["admin", "agent", "bpo_closer"].includes(role);
  const contactId = facts?.lead_id || facts?.client_id || "";
  return {
    allowed: Boolean(roleAllowed && facts?.callable === true && facts?.phone && contactId),
    contactId,
    contactType: facts?.lead_id ? "lead" : facts?.client_id ? "client" : "",
  };
}

export function canonicalPhoneCorrectionGate(facts, role) {
  const roleAllowed = ["admin", "ops_manager", "agent"].includes(role);
  const contactId = facts?.lead_id || facts?.client_id || "";
  return {
    allowed: Boolean(roleAllowed && contactId),
    contactId,
    contactType: facts?.lead_id ? "lead" : facts?.client_id ? "client" : "",
  };
}
